import { getSlateEditorValue } from '@doltech/utils/lib/editor';
import * as React from 'react';
import styled from 'styled-components';
import { BlogEditorReadOnlyWithStylesWithoutStore } from '@doltech/ui/lib/figma/BlogEditor/BlogEditorReadOnlyWithStylesPlugin';

const Main = styled(BlogEditorReadOnlyWithStylesWithoutStore)`
  display: grid;
  padding-left: 24px;
  border-left: 4px solid rgba(0, 0, 0, 0.8);
  min-height: initial;
`;

export const QuestionTitlePreview = ({ value }) => {
  const initialValue = React.useMemo(() => {
    return getSlateEditorValue(value?.content);
  }, [value?.content]);
  return <Main className="question-title" initialValue={initialValue} isReadOnly />;
};
